import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import CartaPorteTiposFiguraForm from './CartaPorteTiposFiguraForm';
import CartaPorteTiposFiguraList from './CartaPorteTiposFiguraList';

class CartaPorteTiposFiguraManager extends Component {
  state = {};

  handleOnAdd = (data) => {
    const { FiguraTransporte = {} } = this.props.data;
    const { TiposFigura = [] } = FiguraTransporte;

    const newData = TiposFigura.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const event = { isValid: true, name: 'figuras' };

    this.props.onChange({
      ...this.props.data,
      FiguraTransporte: {
        TiposFigura: data
      }
    }, event);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { FiguraTransporte = {} } = this.props.data;
    const { TiposFigura = [] } = FiguraTransporte;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Figura Transporte</strong>
        </div>

        <div className="section">
          <div className="pt-2">
            <CartaPorteTiposFiguraForm
              data={ data }
              onAdd={ this.handleOnAdd }
            />
          </div>

          <div className="pt-2">
            <CartaPorteTiposFiguraList
              data={ TiposFigura }
              onEdit={ this.handleOnEdit }
              onChange={ this.handleOnListChange }
            />
          </div>
        </div>
      </div>
    )
  }
}

export default CartaPorteTiposFiguraManager;